import React from "react";
import ReactDOM from "react-dom";
import Root from "./routes";
// import i18n (needs to be bundled ;))
import "./i18n";
import "./styles/styles.css";
import "./styles/aurora/aurora-styles.css";
import "core-js/stable";
import "regenerator-runtime/runtime";
import { loadReCaptcha } from "./components/Guard";
import { ARGUS_APM } from "./apm";

loadReCaptcha();
ARGUS_APM.setInitialPageLoadName("home");
ReactDOM.render(<Root />, document.getElementById("app-root"));
